import * as Echarts from 'echarts';

// 系统名称
const systemName = 'Buding后台管理系统';

// 全局参数
let paramData = {data: []};
// 系统参数ID
let sysParamId = '1200';

// 分类数据
let categoryData = {data: []};

// echarts图表
let echarts = Echarts;

// Home页面Tab标签页
let editableTabs = {
    data: [{
        title: '首页',
        name: '/buding/index',
        close: false
    }]
}
// Home页面当前活动的标签页
let editableTabsValue = {
    data: '/buding/index'
}

// 表格渲染颜色等级
// TODO 待移动到color.js
let colorLevel = {
    level0: '#00c6be',
    level1: '#ff6400',
    level2: '#ff41c1',
    level3: '#c985ff',
    level4: '#5dabdb',
    level5: '#8dcd4d',
    level6: '#c0c2c7',
    level7: '#dbdfe2',
}

// 表格颜色渲染
function calcColor(row, column, dataMap) {
    let field = column.property;
    let value = row[field];
    return colorLevel['level' + dataMap.get(value)];
}

// 按钮点击后恢复原来的背景色
function btnResume(event) {
    let target = event.target;
    if (target.nodeName === 'BUTTON') {
        // 直接点击到了按钮
        target.blur();
    } else if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
        // SPAN是按钮的文字，I是按钮的图标
        let parentTarget = target.parentNode;
        if (parentTarget.nodeName === 'BUTTON') {
            parentTarget.blur();
        }
    }
}

export default {
    // 全局参数
    systemName,
    paramData,
    sysParamId,
    categoryData,
    echarts,
    editableTabs,
    editableTabsValue,
    colorLevel,

    // 全局方法
    btnResume,
    calcColor,
}